module.exports = __webpack_public_path__ + "static/energy_17-95abd3ede6fe163aa8777b6324e11a4b.jpg";